<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">物资清单</div>
        <el-form
          class="zj-search-form clear"
          ref="form"
          :model="form"
          :label-width="labelWidth"
          v-if="isShowSearch"
        >
          <el-form-item label="物资类型">
            <el-select v-model="materialType" placeholder="请选择" style="width:35rem">
              <el-option>请选择</el-option>
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" - " v-if="false">
            <el-select v-model="subType" placeholder="请选择" style="width:35rem">
              <el-option
                v-for="item in optionsnext"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="存放仓库">
            <el-select v-model="warehouseId" placeholder="请选择" style="width:35rem">
              <el-option>请选择</el-option>
              <el-option
                v-for="item in warehouselist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物资名称">
            <el-input v-model="name" style="width:35rem"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0px;" v-loading="searching" element-loading-text="搜索中">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onOuthouse">出 库</el-button>
              <el-button size="mini" @click="onInhouse">入 库</el-button>
              <el-button size="mini" @click="onAdd">添 加</el-button>
              <el-button size="mini" @click="onbatchDel">删 除</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
            <el-table
              class="table-default"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column type="selection" prop="name" width="40" align="center" v-if="isShowSearch"></el-table-column>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="物资储备名称"></el-table-column>
              <el-table-column
                prop="materialType"
                label="物资装备类型"
                :formatter="materialType"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-for="item in options" :key="item.id">
                    <span v-if="item.code == scope.row.materialType">{{ item.value }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="库存数量" align="center"></el-table-column>
              <el-table-column prop="warehouseId" label="存放仓库" :formatter="warehouseId" align="center">
                <template slot-scope="scope">
                  <span v-for="item in warehouselist" :key="item.id">
                    <span v-if="item.id == scope.row.warehouseId">{{ item.name }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="responsiblePerson" label="负责保管人" align="center"></el-table-column>
              <el-table-column prop="mobileNo" label="移动电话" align="center"></el-table-column>
              <el-table-column
                prop="modifydate"
                label="修改日期"
                :formatter="formatDate"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" width="150" align="center" v-if="isShowSearch">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <el-dialog v-dialogDrag title="物资入库" :visible.sync="dialogOpts.dialogTableVisible">
      <ZjMaterialInWarehouse
        v-if="dialogOpts.dialogTableVisible"
        :viewData="dialogOpts.rowlist"
        :materialTypedate="materialTypedate"
        @cancel="dialogCancel"
        @ok="dialogOk"
        @search="search"
      />
    </el-dialog>
    <el-dialog v-dialogDrag title="物资出库" :visible.sync="dialogOpts.dialogTable2Visible">
      <ZjMaterialOutWarehouse
        v-if="dialogOpts.dialogTable2Visible"
        :viewData2="dialogOpts.rowlist2"
        :materialTypedate2="materialTypedate2"
        @cancel="dialogCancel2"
        @ok="dialogOk2"
        @search="search"
      />
    </el-dialog>
  </div>
</template>

<script>
import ZjMaterialInWarehouse from "./MaterialInWarehouse";
import ZjMaterialOutWarehouse from "./MaterialOutWarehouse";

import { materialList, materialRemove } from '@/api/src/emergency_material'
import { getDictionary } from '@/api/src/emergency_common'
import { warehouseList } from '@/api/src/emergency_warehouse'
export default {
  name: "ZjMateriallist",
  controller: "UI",
  action: "Materiallist",
  props: {
    WarehouseId: String,
    query: {
      obj: String,
      type: String
    }
  },
  data() {
    return {
      loading: true,
      loadingText: "加载中...",
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      name: "",
      options: [],
      materialType: "",
      optionsnext: [],
      subType: "",
      warehouselist: [],
      warehouseId: "",
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null
      },
      materialTypedate: null,
      materialTypedate2: null,
      MaterialTypeDic: [],
      isShowSearch: true
    };
  },
  components: {
    ZjMaterialInWarehouse,
    ZjMaterialOutWarehouse
  },
  created: function() {
    this.basedatabind();
    this.isShowSearch = this.$props.query.type == "search" ? false : true;
    this.warehouseId = this.$props.query.warehouseId ? this.$props.query.warehouseId : '';
  },
  mounted: function() {
    this.$nextTick(() => {
      this.search();
    });
  },
  watch: {
    WarehouseId: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        console.log(val)
        console.log(oldVal)   
        this.WarehouseId = val; 
        this.search(val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      //存放仓库的查询条件
      let searchInfo = {
        size: 2000,
        current: 1
      };

      this.loading = true;
      this.loadingText = "加载中...";
      getDictionary('emergency_material_type')
        .then(res => {
          //物资类型
          this.options = res.data.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
        //仓库列表
      warehouseList(searchInfo)
        .then(res => {
          this.warehouselist = res.data.records;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
      this.materialTypedate = this.MaterialTypeDic;
      this.materialTypedate2 = this.MaterialTypeDic;
    },
    search(val) {
      let searchInfo = {
        name: this.name,
        materialType: this.materialType,
        warehouseId: val||this.warehouseId,
        size: this.pageSize,
        current: this.currentPage,
      };
      this.searching = true;
      materialList(searchInfo).then(r => {
        // console.log("r")
        // console.log(r)
       let  res = r.data;
        this.tableData = res.records;
        this.total = r.total;
        this.searching = false;
      }).catch(e => {
        console.error(e);
        this.searching = false;
      });
    },

    clearsearch() {
      this.name = "";
      this.materialType = "";
      this.subType = "";
      this.warehouseId = "";
    },

    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },

    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          id: row.id,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          id: row.id,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/ui/Materialinfo",
        // name: 'mallList',
        query: {
          id: "",
          type: "edit"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (this.selectData != undefined) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let selectData = []
          this.selectData.forEach(item => {
            selectData.push(item.id)
          });
          const count = selectData.length;
          // 清除 所有勾选项
          this.$refs.multipleTable.clearSelection();
          if (count > 0) {
            this.loading = true;
            this.loadingText = "删除中...";
            materialRemove({ idList: selectData.toString()})
              .then(r => {
                r = r.data;
                if (r) {
                  this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
                this.loading = false;
                this.logInfo.ActionName = "应急物资删除";
                this.logInfo.LogMessage = r ? "应急物资删除成功" : "应急物资删除失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急物资列表页面";
                this.addOperationLog();
                this.search();
              })
              .catch(e => {
                console.error(e);
                this.loading = false;
              });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        materialRemove({ idList: row.id})
          .then(r => {
            r = r.data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            }
            this.loading = false;
            this.logInfo.ActionName = "应急物资删除";
            this.logInfo.LogMessage = r ? "应急物资删除成功" : "应急物资删除失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资列表页面";
            this.addOperationLog();
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      });
    },
    //入库按钮
    onInhouse() {
      if (this.selectData != undefined && this.selectData.length > 0) {
        this.dialogOpts.dialogTableVisible = true;
      } else {
        this.$message({
          type: "info",
          message: "请选择要入库的数据！"
        });
      }
    },
    //出库按钮
    onOuthouse() {
      console.log(this.selectData)
      if (this.selectData != undefined && this.selectData.length > 0) {
        for (var i = 0; i < this.selectData.length; i++) {
          var item = this.selectData[i];
          if (item.StockNum <= 0) {
            this.$message({
              type: "info",
              message: "选择的库存[" + item.name + "]数量不足"
            });
            return;
          }
        }
        this.dialogOpts.dialogTable2Visible = true;
      } else {
        this.$message({
          type: "info",
          message: "请选择要出库的数据！"
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.MaterialTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    dialogOk() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogCancel() {
      this.dialogOpts.dialogTableVisible = false;
    },
    dialogOk2() {
      this.dialogOpts.dialogTable2Visible = false;
    },
    dialogCancel2() {
      this.dialogOpts.dialogTable2Visible = false;
    }
  }
};
</script>
<style lang="css" scoped>
.table-default  /deep/.el-table__body-wrapper {
    height: calc(100% - 44px) !important;
  }
</style>

